<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display sql-group-dialog"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>DB Adapter SQL</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>

    <v-row class="ml-4 mr-4 data-section pt-5 pb-2">
      <v-col class="pb-0 pt-0 mt-0" cols="12" lg="6" md="6">
        <v-row class="page-tab">
          <v-col class="pt-0" cols="12">
            <v-tabs v-model="tab" class="custom-tab-bar" background-color="primary">
              <v-tab
                :class="[$vuetify.theme.dark ? 'mr-1' : '']"
                v-for="item in items"
                :key="item.tab"
              >
                {{ item.content }}
              </v-tab>
            </v-tabs>

            <v-tabs-items class="custom-tab-content" style="height: 620px" v-model="tab">
              <v-tab-item no-animation :key="'normal'">
                <DBAdapterSQLTable
                  :tab="tab"
                  :isLoading="isLoading"
                  :items="normalList"
                  :selectedRowGroup="selectedRowGroup"
                  :dataPoolList="dataPoolList"
                  @click-code-group="onClickCodeGroup"
                  @delete-item="deleteItem"
                />
              </v-tab-item>
              <v-tab-item no-animation :key="'D2D'">
                <DBAdapterSQLTable
                  :tab="tab"
                  :isLoading="isLoading"
                  :items="d2dList"
                  :selectedRowGroup="selectedRowGroup"
                  :dataPoolList="dataPoolList"
                  @click-code-group="onClickCodeGroup"
                  @delete-item="deleteItem"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-col>

      <v-col class="py-0 mt-0" cols="12" lg="6" md="6">
        <v-row class="comm-header-col data-query-section pb-0 pt-0 custom-figma-1">
          <v-col class="py-0 pr-3 pl-4 mt-0" cols="12" lg="12" md="12">
            <v-row>
              <v-col cols="4" class="py-0">
                <v-text-field
                  v-model="queryPoolItems.sql_cnt_nm"
                  :placeholder="
                    $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.conditionSearch.queryName')
                  "
                  @keyup.enter="getQueryPoolList()"
                  dense
                  hide-details
                  filled
                  :disabled="selectedRowGroup === ''"
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="py-0 pl-0">
                <div class="d-flex align-center pa-0">
                  <v-select
                    v-model="queryPoolItems.sql_cnt_tp"
                    :items="searchTypeDBList"
                    class="custom-selectbox label-peer-text"
                    :menu-props="{ offsetY: true }"
                    label="Type"
                    @change="getQueryPoolList()"
                    dense
                    hide-details
                    filled
                    :disabled="selectedRowGroup === ''"
                    style="width: 180px"
                  ></v-select>
                </div>
              </v-col>
              <v-col cols="4" class="py-0 pl-0">
                <v-text-field
                  v-model="queryPoolItems.sql_cnt_txt"
                  :placeholder="
                    $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.conditionSearch.queryText')
                  "
                  @keyup.enter="getQueryPoolList()"
                  dense
                  hide-details
                  filled
                  :disabled="selectedRowGroup === ''"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="h-5"></v-row>
        <v-row class="btn-form-control code-tbl-btn-control">
          <v-col cols="12" class="pt-0 pb-0 pl-0">
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="12" lg="3" md="3" class="pt-0 pb-0 mb-2 text-right">
                <v-btn class="btn btn-top btn-add" @click="openQueryPoolDialog">{{
                  $t('btn.dataSource.sqlGroupView.queryPool')
                }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pt-1 pb-0 pl-0">
            <v-row no-gutters>
              <v-col cols="12" lg="12" md="12" class="code-data-range">
                <v-data-table
                  :headers="showHeaders"
                  :items="dataPoolList"
                  :fixed-header="true"
                  :footer-props="{ showFirstLastPage: true }"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  :height="tableHeightDataPool"
                  :class="[
                    'list-table code-table srm-list-table custom-border-table',
                    dataPoolList.length > 0 ? '' : 'custom-border-table-not-data',
                  ]"
                  hide-default-footer
                  no-data-text="No matching records found"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        v-for="(item, index) in items"
                        :key="index"
                        :class="[selectedRowPool == item.sql_cnt_id ? 'selected_row' : '']"
                      >
                        <td class="text-center">{{ (page - 1) * itemsPerPage + index + 1 }}</td>
                        <td>{{ item.sql_cnt_nm }}</td>
                        <td class="custom-type-db">{{ item.sql_cnt_tp }}</td>
                        <td class="custom-trim-text">{{ item.sql_cnt_txt }}</td>
                        <td v-if="selectedRowGroupData.sql_grp_type === 'D'" class="text-center">
                          {{ item.sql_src_trg_flag }}
                        </td>
                        <td v-if="selectedRowGroupData.sql_grp_type === 'D'" class="text-center">
                          {{ item.sql_db_instance }}
                        </td>
                        <td v-if="selectedRowGroupData.sql_grp_type === 'D'" class="text-center">
                          {{ item.sql_func_type }}
                        </td>
                        <td v-if="selectedRowGroupData.sql_grp_type === 'D'" class="text-center">
                          {{ item.sql_content_seq }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider class="deviderColor mx-3 mt-4 mb-2"></v-divider>
    <v-row class="no-gutters btn-code-section">
      <v-col cols="12" lg="12" class="pa-0 text-right pr-4">
        <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
          {{ $t('btn.common.close') }}
        </v-btn>
      </v-col>
    </v-row>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      size="max"
      :info="deleteDataName"
      title="confirmDialog"
      :detail="$t('msg.dataSource.sqlGroup.deleteConfirm')"
      color="confirmation"
      :dataValue="deleteData"
      @select-ok="okDeleteFile($event)"
      :showCancel="true"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import $ from 'jquery';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { mapState } from 'vuex';
import DBAdapterSQLTable from '@/vue-caas/views/dbadapter/DBAdapterSQLTable.vue';

export default {
  components: {
    DialogDrag,
    IconSvg,
    dialogWindow,
    DBAdapterSQLTable,
  },
  props: {
    id: String,
    title: String,
    type: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    typeDBList: Array,
    searchTypeDBList: Array,
  },
  data() {
    return {
      selectedRowGroup: '',
      itemsPerPage: 100,
      dataPoolList: [],
      page: 1,
      tableHeightDataPool: '554px',
      codeDataPool: [],
      selectedRowGroupData: '',
      selectedRowPool: '',
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      deleteData: {
        sql_grp_id: '',
        sql_grp_type: '',
      },
      deleteDataName: '',
      isLoading: false,
      deleteItems: {
        sql_grp_id: '',
        sql_grp_type: '',
      },
      queryPoolItems: {
        sql_cnt_nm: '',
        sql_cnt_tp: '',
        sql_cnt_txt: '',
        r_from: 1,
        r_to: this.itemsPerPage,
        sort: 'UPDATE',
      },
      QueryPool: {
        headers: [],
        headersDefault: [
          {
            text: this.$t('tbl.datasource.queryPool.no'),
            value: 'rowid',
            align: 'center',
            sortable: false,
          },
          {
            text: this.$t('tbl.datasource.queryPool.queryName'),
            value: 'sql_cnt_nm',
            width: '120px',
            align: 'center',
          },
          {
            text: this.$t('tbl.datasource.queryPool.type'),
            value: 'sql_cnt_tp',
            align: 'center',
          },
          {
            text: this.$t('tbl.datasource.queryPool.queryText'),
            value: 'sql_cnt_txt',
            align: 'center',
          },
        ],
        addHeaders: [
          {
            text: this.$t('tbl.datasource.queryPool.dbType'),
            align: 'center',
            sortable: false,
          },
          {
            text: this.$t('tbl.datasource.queryPool.dbInstance'),
            align: 'center',
            sortable: false,
          },
          {
            text: this.$t('tbl.datasource.queryPool.func'),
            align: 'center',
            sortable: false,
          },
          {
            text: this.$t('tbl.datasource.queryPool.seq'),
            align: 'center',
            sortable: false,
          },
        ],
      },
      sqlGroupData: [],
      tab: null,
      items: [
        { tab: 'normal', content: 'Normal' },
        { tab: 'D2D', content: 'D2D' },
      ],
      normalList: [],
      d2dList: [],
    };
  },
  methods: {
    getGroupList() {
      this.isLoading = true;
      this.queryPoolItems.sql_grp_type = '';
      this.$store
        .dispatch('getSQLGroupList', this.queryPoolItems)
        .then((res) => {
          this.sqlGroupData = res;
          this.normalList = this.sqlGroupData.filter((item) => item.sql_grp_type === 'S');
          this.d2dList = this.sqlGroupData.filter((item) => item.sql_grp_type === 'D');
          let count = res.length;
          if (typeof res !== 'undefined' && count > 0) {
            this.selectedRowGroup = res[count - 1].sql_grp_id;
            this.selectedRowGroupData = res[count - 1];
          } else {
            this.selectedRowGroup = '';
            this.selectedRowGroupData = '';
          }
          this.getQueryPoolList();
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    onClickCodeGroup(item) {
      this.selectedRowGroup = item.sql_grp_id;
      this.selectedRowGroupData = item;
      if (item.sql_grp_id != undefined && item.sql_grp_id != null) this.getQueryPoolList();
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    deleteItem(item) {
      this.deleteData.sql_grp_id = item.sql_grp_id;
      this.deleteData.sql_grp_type = item.sql_grp_type;
      this.deleteDataName = item.sql_grp_nm;
      this.$refs.confirmDeleteFileDialog.dialog = true;
    },
    okDeleteFile(item) {
      this.deleteItems = item;
      this.$store.dispatch('deleteSQLGroup', this.deleteItems).then((res) => {
        this.getGroupList();
      });
    },
    getQueryPoolList() {
      if (this.selectedRowGroup) {
        this.queryPoolItems.sql_grp_id = this.selectedRowGroup;
        this.queryPoolItems.r_from = this.itemsPerPage * (this.page - 1) + 1;
        this.queryPoolItems.r_to = this.itemsPerPage * this.page;
        this.queryPoolItems.sql_grp_type = this.selectedRowGroupData.sql_grp_type;
        this.$store
          .dispatch('getQueryPoolSGList', this.queryPoolItems)
          .then((res) => {
            this.dataPoolList = res.queryPoolList;
            this.codeDataPool = res.queryPoolList;
          })
          .catch((ex) => {});
      } else {
        this.dataPoolList = [];
        this.codeDataPool = [];
      }
    },
    openQueryPoolDialog() {
      EventBus.$emit('openSqlPool');
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  created() {
    if (this.type === 'D2D') {
      this.tab = 1;
    }
    this.$auth.manage = true;
    this.getGroupList();

    EventBus.$on('getGroupList', this.getGroupList);
  },
  computed: {
    showHeaders() {
      if (this.selectedRowGroupData.sql_grp_type === 'D') {
        return this.QueryPool.headers.concat(
          this.QueryPool.headersDefault,
          this.QueryPool.addHeaders
        );
      } else {
        return this.QueryPool.headers.concat(this.QueryPool.headersDefault);
      }
    },
  },
};
</script>
<style>
.sql-group-dialog
  .comm-header-col.data-query-section
  .v-input.label-peer-text
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-label--active {
  top: 19px !important;
  left: 0px !important;
  color: gray !important;
}

.sql-group-dialog
  .comm-header-col.data-query-section
  .v-input.label-peer-text
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-select__selections {
  margin-left: 60px !important;
  padding-top: 1px !important;
}

.sql-group-dialog
  .comm-header-col.data-query-section
  .v-input.label-peer-text
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-input__append-inner {
  margin-top: 5px !important;
}
</style>
